import { render, staticRenderFns } from "./EditTrafficTypes.vue?vue&type=template&id=7086da4a&scoped=true"
import script from "./EditTrafficTypes.vue?vue&type=script&lang=ts"
export * from "./EditTrafficTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086da4a",
  null
  
)

export default component.exports